export default __webpack_public_path__ + "static/media/404.fa277ec6.svg";